import script from "./RemovableMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./RemovableMedia.vue?vue&type=script&setup=true&lang=js"

import "./RemovableMedia.vue?vue&type=style&index=0&id=cf5c223e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf5c223e"]])

export default __exports__